// Replace only the three fragrance-category images and the two Christmas graphics.
(()=>{
 const map=JSON.parse(document.getElementById('veluma-live-images-map').textContent);
 function update(img){
  if(!(img instanceof HTMLImageElement))return;
  let target;
  for(const value of [img.getAttribute('src'),img.getAttribute('data-src')]){
   if(!value)continue;
   try{target=map[new URL(value,location.href).pathname.split('/').pop()]}catch{}
   if(target)break;
  }
  if(!target||img.getAttribute('src')===target)return;
  img.removeAttribute('srcset');img.removeAttribute('data-srcset');img.removeAttribute('data-src');
  img.closest('picture')?.querySelectorAll('source').forEach(s=>s.remove());
  img.src=target;img.dataset.velumaLiveImage='true';
 }
 document.querySelectorAll('img').forEach(update);
 new MutationObserver(entries=>{for(const e of entries){if(e.type==='attributes')update(e.target);else for(const n of e.addedNodes){if(n.nodeType===1){update(n);n.querySelectorAll?.('img').forEach(update)}}}}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
})();
